import { useTranslation } from 'react-i18next';
import { Box, Stack, Typography } from '@mui/material';
import { Button } from './ui/Button';
import { colorTokens } from '../app/designTokens';
import { savedCardCanSubmit, savedCardStatusKey } from '../utils/savedCardSetup';

const { semantic } = colorTokens;

export function SavedCardSection({
  summary,
  consentAccepted,
  onConsentChange,
  onAdd,
  onRevoke,
  onRemove,
  busy,
}) {
  const { t } = useTranslation('stripe');
  const version = summary?.consent_version || '';
  const method = summary?.method || null;
  const canSubmit = savedCardCanSubmit({
    setupAvailable: summary?.setup_available === true,
    consentAccepted,
    consentVersion: version,
    confirmed: method?.confirmed === true,
  });

  return (
    <Box
      sx={{
        mb: 2.5,
        p: 2,
        borderRadius: '12px',
        border: `1px solid ${semantic.border.default}`,
        background: semantic.bg.surface,
      }}
    >
      <Typography sx={{ fontWeight: 700, mb: 1 }}>{t('savedCard.title')}</Typography>
      <Typography sx={{ color: semantic.text.muted, mb: 1 }}>{t('savedCard.bankTransferRemains')}</Typography>
      <Typography sx={{ color: semantic.text.muted, mb: 1 }}>{t('savedCard.separateFromTrial')}</Typography>
      <Typography sx={{ color: semantic.text.muted, mb: 1.5 }}>{t('savedCard.legalTextAbsent')}</Typography>
      {summary?.setup_available !== true && (
        <Typography sx={{ color: semantic.text.muted, mb: 1.5 }}>{t('savedCard.unavailable')}</Typography>
      )}
      {version !== '' && (
        <Typography sx={{ mb: 1.5 }}>
          {summary?.consent_is_test_fixture === true
            ? t('savedCard.testFixture', { version })
            : version}
        </Typography>
      )}
      <Typography sx={{ mb: 1.5 }} data-testid="saved-card-status">
        {t(savedCardStatusKey(method))}
        {method?.card?.last4 ? ` ${t('savedCard.cardLabel', method.card)}` : ''}
      </Typography>
      {method?.confirmed !== true && (
        <Stack spacing={1.5}>
          <label>
            <input
              type="checkbox"
              checked={consentAccepted === true}
              disabled={summary?.setup_available !== true || busy}
              onChange={(event) => onConsentChange(event.target.checked)}
            />
            {' '}
            {t('savedCard.checkbox', { version: version || '—' })}
          </label>
          <Box>
            <Button variant="Secondary" disabled={!canSubmit || busy} onClick={onAdd}>
              {t('savedCard.addCard')}
            </Button>
          </Box>
        </Stack>
      )}
      {method?.confirmed === true && (
        <Stack direction="row" spacing={1}>
          <Button variant="Ghost" disabled={busy} onClick={onRevoke}>{t('savedCard.revoke')}</Button>
          <Button variant="Ghost" disabled={busy} onClick={onRemove}>{t('savedCard.remove')}</Button>
        </Stack>
      )}
    </Box>
  );
}
